import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const Security = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Security</h3>

      <p>
        We take reasonable administrative, technical, and organizational
        measures designed to protect personal information against unauthorized
        access, use, disclosure, alteration, loss, or destruction.
      </p>

      <p>
        Our security measures may include access controls, account
        authentication, role-based permissions, restricted administrative
        access, secure transmission of information, and the use of reputable
        third-party hosting, storage, payment processing, and technology service
        providers.
      </p>

      <p>
        Access to information within the platform is limited according to user
        roles and permissions. For example, company managers may access
        information associated with users under their company account, while
        subcontractors may access only the forms, manuals, or other resources
        for which they have been granted permission. Administrative access is
        restricted to authorized individuals who require access to operate,
        maintain, support, or secure the platform.
      </p>

      <p>
        Payment card information is processed by Stripe or another authorized
        payment processor and is not stored by Yoda Safety Services.
      </p>

      <p>
        While we take reasonable steps to protect personal information, no
        method of transmission over the Internet or method of electronic storage
        can be guaranteed to be completely secure. Accordingly, we cannot
        guarantee absolute security.
      </p>

      <p>
        Users are responsible for maintaining the confidentiality of their
        account credentials and should not share their login information with
        unauthorized individuals. If you believe your account or personal
        information may have been accessed or used without authorization, please
        contact us promptly at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        .
      </p>

      <p>
        If a privacy or security incident involving personal information occurs,
        we will investigate and respond as appropriate and will provide
        notifications or reports where required by applicable law.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Security;
